<template>
  <div class="stepper">
    <div
      v-for="stepNumber in 10"
      :key="stepNumber"
      :class="[
        'stepper__step',
        { 'stepper__step--active': step === stepNumber },
        { hidden: step === 'registration' },
      ]"
    >
      <!-- Empty div to create the dot -->
    </div>
  </div>
  <!-- <div>
    {{ parsedFormValues }}
  </div> -->
  <form
    v-if="step === 1"
    @submit.prevent="saveAndContinue"
    class="death-peddler-form"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_zero_header'] }}
        </h4>
        <div class="death-peddler-form__options">
          <div class="death-peddler-form__option--button">
            <input
              id="beverages"
              type="radio"
              name="merchflow"
              v-model="merchflow"
              value="beverages"
              class="death-peddler-form__radio"
              required
            />
            <label class="death-peddler-form__label font-bold" for="beverages">
              BEVERAGES
            </label>
          </div>
          <div class="death-peddler-form__option--button">
            <input
              id="merch"
              type="radio"
              name="merchflow"
              v-model="merchflow"
              value="merch"
              class="death-peddler-form__radio"
              required
            />
            <label class="death-peddler-form__label font-bold" for="merch">
              MERCH
            </label>
          </div>
          <div class="death-peddler-form__option--button">
            <input
              id="both"
              type="radio"
              name="merchflow"
              v-model="merchflow"
              value="merch-and-beverages"
              class="death-peddler-form__radio"
              required
            />
            <label class="death-peddler-form__label font-bold" for="both">
              BOTH
            </label>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <button type="submit" class="death-peddler-form__button--primary m-0">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-if="step === 2"
    @submit.prevent="saveAndContinue"
    class="death-peddler-form"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_one_header'] }}
        </h4>
        <div class="death-peddler-form__options">
          <div
            v-for="(option, index) in businessTypes"
            :key="index"
            class="death-peddler-form__option"
          >
            <input
              :id="option.id"
              name="business-type"
              type="radio"
              class="death-peddler-form__radio"
              v-model="selectedBusinessType"
              :value="option.id"
              required
            />
            <label :for="option.id" class="death-peddler-form__label">{{
              option.label
            }}</label>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-else-if="step === 3"
    @submit.prevent="saveAndContinue"
    autocomplete="on"
    class="death-peddler-form"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_two_header'] }}
        </h4>
        <div class="death-peddler-form__options">
          <div class="death-peddler-form__option--button">
            <input
              id="distributor"
              type="radio"
              name="flow"
              v-model="flow"
              value="distributor"
              class="death-peddler-form__radio"
              required
            />
            <label
              class="death-peddler-form__label font-bold"
              for="distributor"
            >
              YES
            </label>
          </div>
          <div class="death-peddler-form__option--button">
            <input
              id="self"
              type="radio"
              name="flow"
              v-model="flow"
              value="self"
              class="death-peddler-form__radio"
              required
            />
            <label class="death-peddler-form__label font-bold" for="self">
              NO
            </label>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <button
        type="button"
        @click="goBack"
        class="death-peddler-form__button--secondary"
      >
        BACK
      </button>
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-else-if="step === 4"
    class="death-peddler-form"
    @submit.prevent="saveAndContinue"
    autocomplete="on"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_three_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="business_name"
            type="text"
            placeholder="Business Name"
            name="business_name"
            v-model="businessName"
            required
            autocomplete="organization"
          />
          <input
            class="death-peddler-form__input"
            id="ein"
            type="text"
            placeholder="EIN (optional)"
            v-model="ein"
            name="ein"
          />
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    autocomplete="on"
    v-else-if="step === 5"
    class="death-peddler-form"
    @submit.prevent="saveAndContinue"
  >
    <div class="death-peddler-form__container">
      <div class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_four_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="street-address"
            type="text"
            placeholder="Street Address"
            name="street-address"
            v-model="streetAddress1"
            required
            autocomplete="street-address"
          />
          <input
            class="death-peddler-form__input"
            id="street_address_2"
            type="text"
            placeholder="Street Address 2 (optional)"
            name="street_address_2"
            v-model="streetAddress2"
          />
          <div class="death-peddler-form__inputs--inline">
            <input
              class="death-peddler-form__input"
              id="postal-code"
              type="text"
              placeholder="Zip code"
              name="postal-code"
              required
              pattern="^\d{5}(?:-\d{4})?$"
              v-model="zipCode"
              autocomplete="postal-code"
            />
            <select
              id="state"
              class="death-peddler-form__input death-peddler-form__select"
              v-model="state"
              required
            >
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </div>
          <input
            class="death-peddler-form__input"
            id="city"
            type="text"
            placeholder="City"
            name="city"
            v-model="streetCity"
            required
            autocomplete="address-level2"
          />
        </div>
      </div>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-else-if="step === 6"
    class="death-peddler-form"
    @submit.prevent="saveAndContinue"
    autocomplete="on"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_five_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="email_address"
            type="email"
            placeholder="Enter Email Address"
            name="email_address"
            v-model="emailAddress"
            required
            autocomplete="email"
          />
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-else-if="step === 7"
    class="death-peddler-form"
    @submit.prevent="saveAndContinue"
    autocomplete="on"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_six_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="applicant_name"
            type="text"
            placeholder="Enter Your Name"
            name="applicant_name"
            v-model="applicantName"
            required
            autocomplete="name"
          />
          <input
            class="death-peddler-form__input"
            id="applicant_role"
            type="text"
            placeholder="Enter Your Role"
            name="applicant_role"
            autocomplete="organization-title"
            v-model="applicantRole"
            required
          />
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button type="submit" class="death-peddler-form__button--primary">
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-if="step === 8"
    class="death-peddler-form"
    @submit.prevent="saveAndContinue"
    autocomplete="on"
  >
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h2
          class="death-peddler-form__title text-center text-lg md:text-xl font-bold leading-6 text-black"
        >
          {{ parsedFormValues['step_seven_header'] }}
        </h2>
        <div class="death-peddler-form__options mt-6 space-y-6">
          <!-- Removed radio options -->
        </div>
      </fieldset>
      <div class="death-peddler-form__price-range mt-6">
        <label
          for="priceRange"
          class="death-peddler-form__label text-base font-medium leading-6 text-black"
          >1</label
        >
        <input
          type="range"
          id="priceRange"
          name="priceRange"
          class="death-peddler-form__slider"
          min="1"
          max="100"
          step="1"
          v-model="selectedCanRange"
          required
        />
        <span class="death-peddler-form__slider-value">100</span>
      </div>
      <p class="text-center">
        I estimate selling {{ selectedCanRange }} cans per month
      </p>
    </div>
    <div
      class="death-peddler-form__buttons mt-6 flex items-center justify-end gap-x-6"
    >
      <button
        class="death-peddler-form__button--secondary text-sm font-semibold leading-6 text-gray-900"
        type="button"
        @click="goBack"
      >
        BACK
      </button>
      <button class="death-peddler-form__button--primary" type="submit">
        CONTINUE
      </button>
    </div>
  </form>

  <form v-else-if="step === 9" class="death-peddler-form">
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_eight_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="instgram_username"
            type="text"
            placeholder="Instagram Username (optional)"
            name="instgram_username"
            v-model="instagramUsername"
          />
          <input
            class="death-peddler-form__input"
            id="tiktok_username"
            type="text"
            placeholder="TikTok Username (optional)"
            name="tiktok_username"
            v-model="tiktokUsername"
          />
          <input
            class="death-peddler-form__input"
            id="facebook_username"
            type="text"
            placeholder="Facebook Username (optional)"
            name="facebook_username"
            v-model="facebookUsername"
          />
          <input
            class="death-peddler-form__input"
            id="other"
            type="text"
            placeholder="Other"
            name="other"
            v-model="otherSocialAccounts"
          />
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button
        @click="saveAndContinue"
        class="death-peddler-form__button--primary"
      >
        CONTINUE
      </button>
    </div>
  </form>

  <form v-else-if="step === 10" class="death-peddler-form">
    <div class="death-peddler-form__container">
      <fieldset class="death-peddler-form__fieldset">
        <h4 class="death-peddler-form__title">
          {{ parsedFormValues['step_nine_header'] }}
        </h4>
        <div class="death-peddler-form__inputs">
          <input
            class="death-peddler-form__input"
            id="comments"
            type="textarea"
            placeholder="Enter comments here..."
            name="comments"
            v-model="comments"
          />
        </div>
      </fieldset>
    </div>

    <div class="death-peddler-form__buttons">
      <span @click="goBack" class="death-peddler-form__button--secondary">
        BACK
      </span>
      <button
        @click="saveAndContinue"
        class="death-peddler-form__button--primary"
      >
        CONTINUE
      </button>
    </div>
  </form>

  <form
    v-else-if="step === 'registration'"
    class="death-peddler-form"
    @submit.prevent="getDistributorsByZip"
  >
    <div class="death-peddler-form__container">
      <img
        class="death-peddler-form__logo"
        src="https://cdn.shopify.com/s/files/1/0079/4289/7737/files/Liquid-Death-Death-Peddlers-Logo.webp?v=1681160662"
        alt="logo"
      />
      <h4 class="death-peddler-form__title">
        {{ parsedFormValues['final_step_header'] }}
      </h4>
      <p class="death-peddler-form__description">
        {{ parsedFormValues['final_step_description'] }}
      </p>

      <div class="death-peddler-form__buttons--center">
        <button
          type="submit"
          @click="submitBusinessSurvey"
          class="death-peddler-form__button--primary max-w-full"
        >
          COMPLETE REGISTRATION
        </button>
      </div>
      <p class="death-peddler-form__description--small">
        By selecting "Complete Registration" I agree to receive important info
        and news from Liquid Death since we will be peddling death together
      </p>
      <!-- <hr style="width: 100%; border-color: #e6e6e6; margin-top: 2rem" /> -->

      <!-- <h3
        class="death-peddler-form__title death-peddler-form__category"
        style="padding-top: 0"
      >
        FULFILLMENT OPTIONS
      </h3> -->

      <!-- <div v-if="this.selectedBusinessType == 'coffee'">
        <h5 class="death-peddler-form__title">
          {{ parsedFormValues['okedo_header'] }}
        </h5>

        <p class="death-peddler-form__description">
          {{ parsedFormValues['okedo_description'] }}
        </p>
        <a
          :href="parsedFormValues['okedo_button_url']"
          class="death-peddler-form__button--secondary max-w-full"
        >
          {{ parsedFormValues['okedo_button_text'] }}
        </a>
      </div>

      <div
        class="death-peddler-form__category"
        v-if="this.selectedBusinessType == 'gym'"
      >
        <h5 class="death-peddler-form__title">
          {{ parsedFormValues['muscle_foods_header'] }}
        </h5>

        <p class="death-peddler-form__description">
          {{ parsedFormValues['muscle_foods_description'] }}
        </p>
        <div class="death-peddler-form__buttons--center">
          <a
            :href="parsedFormValues['muscle_foods_button_url']"
            class="death-peddler-form__button--secondary max-w-full"
          >
            {{ parsedFormValues['muscle_foods_button_text'] }}

            GO TO MUSCLE FOODS
          </a>
        </div>
      </div> -->

      <!-- <div class="death-peddler-form__category">
        <div class="death-peddler-form__results">
          <h5 class="death-peddler-form__title">
            {{ parsedFormValues['distributors_header'] }}
          </h5>
          <p class="death-peddler-form__description">
            {{ parsedFormValues['distributors_description'] }}

            Showing distributors for the area of {{ this.zipCode }}.
          </p>
          <div
            v-for="distributor in matchedDistributors"
            :key="distributor['Zip Code']"
            class="death-peddler-form__result"
          >
            <h3 class="death-peddler-form__result--name">
              {{ distributor.Distributor }}
            </h3>
            <span class="death-peddler-form__result--state">
              {{ distributor['State Abb.'] }}
            </span>
            <span class="death-peddler-form__result--zip">
              {{ distributor['Zip Code'] }}
            </span>
            <a
              v-if="distributor['URL']"
              :href="distributor['URL']"
              class="death-peddler-form__result--url"
              target="_blank"
              aria-label="Opens in new window"
              rel="noopener noreferrer"
            >
              Visit Website
            </a>
            <span
              v-if="distributor['Phone Number']"
              class="death-peddler-form__result--phone"
            >
              {{ distributor['Phone Number'] }}
            </span>
          </div>

          <div
            v-if="matchedDistributors.length === 0"
            class="no-distributors-found"
          >
            <h2>No Distributor Results</h2>
            <p>Please try another zip code.</p>
          </div>
        </div>
      </div> -->
      <!-- 
      <div class="death-peddler-form__category">
        <h5 class="death-peddler-form__title">
          {{ parsedFormValues['self_fulfill_header'] }}
        </h5>
        <p class="death-peddler-form__description">
          {{ parsedFormValues['self_fulfill_description'] }}
        </p>
        <div class="death-peddler-form__buttons--center">
          <a
            class="death-peddler-form__button--secondary max-w-full"
            href="/pages/where-to-buy"
          >
            RETAIL
          </a>
          <a
            class="death-peddler-form__button--secondary max-w-full"
            target="_blank"
            aria-label="Opens in new window"
            href="https://www.amazon.com/stores/LiquidDeath/page/26246089-7E2F-43AA-B962-F441768C411B?ref_=ast_bln"
          >
            AMAZON
          </a>
        </div>
      </div>
      <div class="death-peddler-form__category">
        <div class="death-peddler-form__buttons--center">
          <button
            type="submit"
            @click="submitBusinessSurvey"
            class="death-peddler-form__button--primary max-w-full"
          >
            COMPLETE REGISTRATION
          </button>
        </div>
      </div> -->
    </div>
  </form>

  <form v-else-if="step === 'merch'" class="death-peddler-form">
    <div class="death-peddler-form__container">
      <img
        class="death-peddler-form__logo"
        src="https://cdn.shopify.com/s/files/1/0079/4289/7737/files/Liquid-Death-Death-Peddlers-Logo.webp?v=1681160662"
        alt="logo"
      />
      <h4 class="death-peddler-form__title">
        {{ parsedFormValues['merch_header'] }}
      </h4>
      <p class="death-peddler-form__description">
        {{ parsedFormValues['merch_description'] }}
      </p>

      <div class="death-peddler-form__category">
        <div class="death-peddler-form__buttons--center">
          <a
            :href="parsedFormValues['merch_button_url']"
            class="death-peddler-form__button--primary max-w-full text-center"
          >
            {{ parsedFormValues['merch_button_text'] }}
          </a>
        </div>
      </div>
    </div>
  </form>
</template>

<style>
.death-peddler-form {
  display: flex;
  flex-direction: column;
}
.death-peddler-form h4,
.death-peddler-form h5 {
  margin-bottom: 24px;
  margin-top: 16px;
}
.death-peddler-form__container {
  padding-bottom: 3rem;
  display: block;
  width: 100%;
}

.death-peddler-form__category {
  padding-top: 3rem;
  display: block;
  width: 100%;
}

.death-peddler-form__title {
  text-align: center;
  font-size: 28px;
  line-height: 1;
}

.death-peddler-form h5 {
  font-size: 23px;
}

.death-peddler-form__logo {
  max-width: 250px;
  display: block;
  margin: auto;
}

.death-peddler-form__description {
  text-align: center;
  font-size: 16px;
}

.death-peddler-form__description--small {
  font-size: 14px;
}
.death-peddler-form__option {
  display: flex;
  align-items: center;
  column-gap: 0.75rem;
  margin-top: 1.5rem;
  cursor: pointer;
}
.death-peddler-form__option--button {
  display: flex;
}

.death-peddler-form__option--button input[type='radio'] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.death-peddler-form__option--button label {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid black;
  border-radius: 0;
  cursor: pointer;
  margin-bottom: 8px;
  background-color: white;
  text-align: center;
}

/* Style the selected radio button */
.death-peddler-form__option--button input:checked + label {
  background-color: black;
  color: white;
}

.death-peddler-form__radio {
  width: 1.5rem;
  height: 1.5rem;
  outline: 2px solid #0000;
  outline-offset: 2px;
  border: black 1px solid;
  color: black;
  cursor: pointer;
  margin-top: -1px;
  appearance: inherit;
  border-radius: 100%;
}
.death-peddler-form__radio:checked {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg viewBox=%270 0 16 16%27 fill=%27%23fff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Ccircle cx=%278%27 cy=%278%27 r=%273%27/%3E%3C/svg%3E');
  background-color: black;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-color: #0000;
  color: black;
}
.death-peddler-form__buttons {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  column-gap: 8px;
}

.death-peddler-form__buttons--center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
}

.death-peddler-form__button--secondary {
  background-color: #fff;
  border: 2px solid #b7a579;
  border-radius: 0;
  color: #b7a579;
  font-family: 'Acumin Pro';
  cursor: pointer;
  font-size: 16px;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  font-weight: 700;
  max-width: 175px;
  /* padding: 1rem 2.5rem; */
  transition-duration: 0.5s;
  width: 100%;
  padding: 12px 16px 9px 16px;
  justify-content: center;
  align-items: center;
}

.death-peddler-form__button--secondary:hover {
  background-color: black;
}

.death-peddler-form__button--primary {
  width: 100%;
  max-width: 175px;
  font-family: 'Acumin Pro';
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 16px 9px 16px;
  transition-duration: 0.5s;
  background-color: black;
  border: 2px solid black;
  color: white;
  text-decoration: none;
  border-radius: 0;
}

.death-peddler-form__button--primary:hover {
  background-color: #b7a579;
  border: 2px solid #b7a579;
  color: white;
}

.death-peddler-form__button--secondary {
  width: 100%;
  max-width: 175px;
  font-family: 'Acumin Pro';
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 16px 9px 16px;
  transition-duration: 0.5s;

  background-color: #b7a579;
  border: 2px solid #b7a579;
  color: white;

  border-radius: 0;
}

.death-peddler-form__button--secondary:hover {
  background-color: black;
  border: 2px solid black;
  color: white;
}

.death-peddler-form__fieldset {
  border: 0px;
  padding: 0;
}
.death-peddler-form__inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;
  column-gap: 0.75rem;
}
.death-peddler-form__inputs--inline {
  flex-direction: row;
  align-items: center;
  width: 100%;
  column-gap: 0.5rem;
  display: flex;
}
.death-peddler-form__input {
  font-size: 16px;
  border: 1px solid rgb(153, 153, 153);
  border-radius: 0;
  width: 100%;
  padding: 11px 12px 10px 16px;
  box-sizing: border-box;
}

.death-peddler-form__select {
  -webkit-print-color-adjust: exact;
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3E%3C/svg%3E');
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  appearance: none;
  -webkit-appearance: none;
}
.death-peddler-form__price-range {
  display: flex;
  align-items: center;
  justify-content: center;
}

.death-peddler-form__label {
  cursor: pointer;
}

.death-peddler-form__slider-value {
  margin-left: 1rem;
  font-size: 1rem;
  font-weight: bold;
}

/* Style the range input */

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 28px;
  height: 28px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

input[type='range']::-moz-range-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 28px;
  height: 28px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

#toSlider::-webkit-slider-thumb {
  margin-top: -2px;
}

input[type='range']::-webkit-slider-thumb:hover {
  background: #f7f7f7;
}

.death-peddler-form__slider {
  width: 80%;
  margin-left: 1rem;
  position: relative;
  /* Remove default styles */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 2px;
  background-color: #c6c6c6;
  pointer-events: none;
}

.death-peddler-form__results {
  border: 1px solid #e6e6e6;
  display: flex;
  padding: 16px;
  flex-direction: column;
}
.death-peddler-form__result {
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
}
.death-peddler-form__result:not(:last-child) {
  border-bottom: 1px solid #e6e6e6;
}
.death-peddler-form__result--name {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0;
  text-transform: uppercase;
}
.death-peddler-form__result--phone,
.death-peddler-form__result--mail {
  text-decoration: unset;
  color: black;
}

.text-center {
  text-align: center;
}

.m-0 {
  margin: 0 auto;
}

.max-w-full {
  max-width: 100%;
}

.font-bold {
  font-weight: 700;
}

.stepper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
}

.stepper__step {
  width: 6px; /* Size of the dot */
  height: 6px;
  background-color: #e6e6e6; /* Inactive dot color */
  border-radius: 50%; /* Makes it a circle */
  margin: 0 5px; /* Spacing between dots */
}

.stepper__step--active {
  background-color: #151515; /* Active dot color */
}
.hidden {
  display: none;
}
</style>

<script>
import { defineComponent, reactive, ref } from 'vue';
import businessTypesData from './businessTypes.json';

export default defineComponent({
  name: 'death-peddler',
  data() {
    return {
      step: 1,
      businessTypes: businessTypesData,
      selectedBusinessType: null,
      businessName: '',
      ein: '',
      distributor: '',
      streetAddress1: '',
      streetAddress2: '',
      streetCity: '',
      zipCode: '',
      state: 'AL',
      emailAddress: '',
      applicantName: '',
      matchedDistributors: [],
      applicantRole: '',
      instagramUsername: '',
      tiktokUsername: '',
      suggestDistributor: '',
      facebookUsername: '',
      selectedCanRange: 20,
      otherSocialAccounts: '',
      comments: '',
      merchflow: null,
      flow: null, // Add this variable
    };
  },
  setup() {
    // This will hold the parsed form values
    const parsedFormValues = ref(null);

    // This will run when the component is mounted
    const setFormValues = () => {
      const formValueElement = document.querySelector(
        '#death-peddler_form_values'
      );

      if (formValueElement) {
        try {
          const jsonData = JSON.parse(formValueElement.textContent);
          parsedFormValues.value = jsonData;
        } catch (e) {
          console.error('Error parsing formValues attribute:', e);
        }
      }
    };

    return {
      parsedFormValues,
      setFormValues,
    };
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    goBack() {
      this.step--; // Move to the previous step
    },
    isValidEmail(email) {
      let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return regex.test(email);
    },
    selfFulfill() {
      if (this.step === 'okedo') {
        this.step = 3;
      } else {
        this.step = 7;
      }
    },
    async submitEmail() {
      const apiUrl =
        'https://us-central1-death-peddlers.cloudfunctions.net/submitBusinessSurvey';

      const postData = {
        email: this.emailAddress,
        businessType: this.selectedBusinessType,
        hasDistributor: this.flow === 'distributor',
        businessName: this.businessName,
        selling: this.merchflow,
        businessEin: this.ein,
        businessStreet1: this.streetAddress1,
        businessStreet2: this.streetAddress2,
        businessCity: this.streetCity,
        businessState: this.state,
        businessZip: this.zipCode,
      };

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ data: postData }),
        });

        const data = await response.json();

        // Assuming the response data contains a field 'uid' with the unique identifier.
        const uid = data.result.uid;

        // Set the UID as a cookie.
        this.setCookie('uid', uid, 365);
      } catch (error) {
        console.error('Error submitting business survey:', error);
        // Handle the error in your Vue component, for instance, show an error message to the user.
      }
    },
    setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    },
    async submitBusinessSurvey(e) {
      e.preventDefault();
      const apiUrl =
        'https://us-central1-death-peddlers.cloudfunctions.net/submitBusinessSurvey';

      // Retrieve cookie value by name
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      }

      let uid = getCookie('uid');
      const storedEmail = getCookie('email');

      // If the UID cookie exists, and the email matches the stored email, use the same UID
      if (uid && storedEmail === this.emailAddress) {
        uid = uid;
      }

      const postData = {
        uid,
        email: this.emailAddress,
        businessType: this.selectedBusinessType,
        hasDistributor: this.flow === 'distributor',
        businessName: this.businessName,
        businessEin: this.ein,
        selling: this.merchflow,
        businessStreet1: this.streetAddress1,
        businessStreet2: this.streetAddress2,
        businessCity: this.streetCity,
        businessState: this.state,
        businessZip: this.zipCode,
        cansSoldPerMonth: this.selectedCanRange,
        fullName: this.applicantName,
        businessRole: this.applicantRole,
        instagramUsername: this.instagramUsername,
        tiktokUsername: this.tiktokUsername,
        facebookUsername: this.facebookUsername,
        otherUsername: this.otherSocialAccounts,
        anythingElse: this.comments,
      };

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ data: postData }), // Wrapped postData inside an object with key "data"
        });

        const data = await response.json();

        // Check if the response is successful (e.g., status code 200 OK)
        if (response.ok) {
          // Navigate to the desired URL

          window.location.href = `https://deathpeddlers.liquiddeath.com/complete-registration?uid=${uid}`;
        } else {
          console.error(
            'Error submitting business survey: Server responded with an error',
            data
          );
          // Handle any specific server errors, e.g., validation errors
        }
      } catch (error) {
        console.error('Error submitting business survey:', error);
        // Handle the error in your Vue component, for instance, show an error message to the user.
      }
    },

    // async redirectToOkedo(e) {
    //   e.preventDefault()
    //   window.location.href = parsedFormValues['okedo_button_url']
    // },

    // async redirectToMuscleFoods(e) {
    //   e.preventDefault()
    //   window.location.href = parsedFormValues['musclefoods_button_url']
    // },

    saveMerchFlow() {
      if (
        this.merchflow === 'beverages' ||
        this.merchflow === 'merch-and-beverages'
      ) {
        this.step = 2;
      } else {
        this.step = 'merch';
      }
    },
    saveBusinessType() {
      if (this.selectedBusinessType) {
        this.step = 3;
      }
    },

    saveFlow() {
      this.step = 4;
    },

    saveBusinessName() {
      if (this.businessName) {
        this.step = 5;
      }
    },

    saveBusinessAddress() {
      if (
        this.streetAddress1 &&
        this.zipCode &&
        this.state &&
        this.streetCity
      ) {
        this.step = 6;
      }
    },

    saveEmail(e) {
      if (this.emailAddress && this.isValidEmail(this.emailAddress)) {
        // if (this.flow === 'distributor') {
        //   this.step = 'store-list'
        //   this.getDistributorsByZip()
        // } else {
        this.step = 7;
        // }
        this.submitEmail();
      }
    },

    async getDistributorsByZip() {
      try {
        // Fetch data from the provided endpoint
        const response = await fetch(
          'https://cdn.shopify.com/s/files/1/0079/4289/7737/files/updatedDistributors.json?v=1692106551'
        );

        if (!response.ok) {
          throw new Error('Failed to fetch distributors data');
        }

        const distributors = await response.json();
        // Filter based on the user's zip code
        this.matchedDistributors = distributors.filter(
          (distributor) => distributor['Zip Code'] === this.zipCode
        );

        return this.matchedDistributors; // Return this.matchedDistributors
      } catch (error) {
        console.error('Error:', error);
        return [];
      }
    },

    saveBusinessPosition() {
      if (this.applicantName && this.applicantRole) {
        this.step = 8;
      }
    },

    saveCanAmount() {
      if (this.selectedCanRange) {
        this.step = 9;
      }
    },

    saveSocials() {
      this.step = 10;
    },

    saveComments() {
      this.step = 'registration';
      this.getDistributorsByZip();
    },
    saveAndContinue(e) {
      e.preventDefault();
      switch (this.step) {
        case 1:
          this.saveMerchFlow();
        case 2:
          this.saveBusinessType();
          break;
        case 3:
          this.saveFlow();
          break;
        case 4:
          this.saveBusinessName();
          break;
        case 5:
          this.saveBusinessAddress();
          break;
        case 6:
          this.saveEmail();
          break;
        case 7:
          this.saveBusinessPosition();
          break;
        case 8:
          this.saveCanAmount();
          break;
        case 9:
          this.saveSocials();
          break;
        case 10:
          this.saveComments();

          break;
      }
    },
  },
});
</script>
